var exports = {
  "kL": "GuildRolesTab.module__container___TjV0Qm",
  "pG": "GuildRolesTab.module__right___TjV0Qm",
  "ze": "GuildRolesTab.module__rightScroller___TjV0Qm",
  "CI": "GuildRolesTab.module__sectionRow___TjV0Qm",
  "bV": "GuildRolesTab.module__sectionHeader___TjV0Qm",
  "Gf": "GuildRolesTab.module__sectionTitle___TjV0Qm",
  "bQ": "GuildRolesTab.module__subtleText___TjV0Qm",
  "u2": "GuildRolesTab.module__sectionSubtitle___TjV0Qm",
  "Zv": "GuildRolesTab.module__displayRow___TjV0Qm",
  "yD": "GuildRolesTab.module__nameField___TjV0Qm",
  "IV": "GuildRolesTab.module__colorField___TjV0Qm",
  "h3": "GuildRolesTab.module__settingsGroup___TjV0Qm",
  "Fs": "GuildRolesTab.module__permSearchRow___TjV0Qm",
  "XZ": "GuildRolesTab.module__permSearchInput___TjV0Qm",
  "HU": "GuildRolesTab.module__permCategories___TjV0Qm",
  "cy": "GuildRolesTab.module__permHeaderRow___TjV0Qm",
  "mA": "GuildRolesTab.module__permHelp___TjV0Qm",
  "p$": "GuildRolesTab.module__emptyState___TjV0Qm",
  "EK": "GuildRolesTab.module__itemWrap___TjV0Qm",
  "hW": "GuildRolesTab.module__roleButton___TjV0Qm",
  "cB": "GuildRolesTab.module__dragging___TjV0Qm",
  "mG": "GuildRolesTab.module__noDrag___TjV0Qm",
  "hz": "GuildRolesTab.module__lockIcon___TjV0Qm",
  "s4": "GuildRolesTab.module__leftTitle___TjV0Qm",
  "rV": "GuildRolesTab.module__overwriteItem___TjV0Qm",
  "w7": "GuildRolesTab.module__overwriteItemSelected___TjV0Qm",
  "MJ": "GuildRolesTab.module__overwriteItemHovered___TjV0Qm",
  "m4": "GuildRolesTab.module__roleDot___TjV0Qm",
  "l": "GuildRolesTab.module__overwriteName___TjV0Qm",
  "xF": "GuildRolesTab.module__mobileRoleList___TjV0Qm",
  "E_": "GuildRolesTab.module__mobileListHeader___TjV0Qm",
  "JJ": "GuildRolesTab.module__mobileListTitle___TjV0Qm",
  "W4": "GuildRolesTab.module__mobileRoles___TjV0Qm",
  "eu": "GuildRolesTab.module__mobileRoleItem___TjV0Qm",
  "Mt": "GuildRolesTab.module__mobileRoleName___TjV0Qm",
  "eP": "GuildRolesTab.module__mobileRoleChevron___TjV0Qm",
  "yg": "GuildRolesTab.module__mobileBackRow___TjV0Qm",
};

module.exports = exports;
